// The actual coloring of the icon svg happens in _icons.scss.
// By default all of the icons they gave us are defaultGray.
// If we use other colors of the icons I apply those in _icons.scss.
export const COLORS = {
	DEFAULT_GRAY: 'default-gray',
	GRAY: 'gray',
	GREEN: 'green',
	WHITE: 'white',
	BLACK: 'black',
	GRAY_PRESENTER: 'gray-presenter', // light gray labels + icons for inputs on presenter app entry flow (teal background)
	PALE_GREEN: 'pale-green',
	PLACEHOLDER_GRAY: 'gray-placeholder',
	RED: 'red',
	LIGHT_BLACK: 'light-black',
	DARK_GRAY: 'dark-gray',
	DARK_GRAY_2: 'dark-gray-2',
	MEDIUM_GRAY: 'med-gray',
	LIGHT_GRAY: 'light-gray',
	TEXT_LIGHT_GRAY: 'text-light-gray',
	TEXT_LIGHT: 'text-light-gray2',
	TEXT_GRAY_100_DISABLED: 'grayscale-100-disabled',
	TEXT_GRAY_100: 'grayscale-100',
	TEXT_GRAY_200: 'grayscale-200',
	TEXT_GRAY_300: 'grayscale-300',
	TEXT_GRAY_400: 'grayscale-400',
	TEXT_GRAY_500: 'grayscale-500',
	TEXT_GRAY_600: 'grayscale-600',
	TEXT_GRAY_700: 'grayscale-700',
	TEXT_GRAY_800: 'grayscale-800',
	TEXT_GRAY_900: 'grayscale-900',
	TEXT_GRAY_1000: 'grayscale-1000',
	TEXT_GRAY_1200: 'grayscale-1200',
	ELECTRIC_400: 'electric-400',
	ELECTRIC_600: 'electric-600',
	SEMANTIC_RED_400: 'semantic-red-400',
	SEMANTIC_RED_500: 'semantic-red-500',
	HOT_PINK: 'bl-hot-pink',
	LEMONADE_PINK: 'bl-lemonade-pink',
	SR_PRIMARY_400: 'sr-primary-400',
	SECONDARY_BLUE_500: 'secondary-blue-500',
};